/* eslint-disable */

/* This file should be imported by the app before anything else. This script
 * will then automatically detect and load appropriate polyfills.
 * 
 * Most polyfills should be imported from relevant node modules, however, if
 * needed special/manual polyfills can be added to the containing 'polyfills'
 * directory as their own files and imported below if necessary.
 */

import 'core-js/es6/promise.js'; // Needed for below code to work (when Promise not natively supported).
import { requirements } from './requirements.js';

function resolveIf(b) {
    return b ? Promise.resolve() : void 0;
}
function promiseScript(src, async) {
    return new Promise(resolve => {
        var s = document.createElement('script');
        s.src = src;
        if (async) s.async = true;
        s.onload = resolve;
        document.head.appendChild(s);
    });
}

// Let WebComponents polyfill-loader know where to find its brethren,
// need to do this otherwise it will just use the relative dir which may be wrong due to bundling.
window.WebComponents = window.WebComponents || {};
window.WebComponents.root = '/node_modules/@webcomponents/webcomponentsjs/';

/**
 * Import this polyfills function and call it when you want to load the polyfills,
 * a Promise is returned which you should then use to execute your app code (now that the polyfills have loaded).
 * A 'done' callback will be passed to the 'then' method which you must execute to indicate that your
 * app code has finished initial bootup, this allows the WebComponents to know when to 'upgrade' the document.
 * 
 * EXAMPLE:
 * import {polyfills} from '...';
 * polyfills().then(done => {
 *   // init your app...
 *   done();
 *   // maybe other stuff...
 * });
 * 
 * @param {object} options Can include polyfill options, defaults: { es5: true }
 */
export const polyfills = function (options) {
    options = options || { es5: true };

    // Load polyfills as needed...
    return Promise.all([

        // window.fetch: we must have fetch or no API requests will work.
        resolveIf('fetch' in window)
        || import(
            /*webpackChunkName:"polyfill-fetch"*/
            'whatwg-fetch/fetch.js'),

        // es6-requirements: if any required polyfills are not found then load a full-on ES6+ polyfill package.
        resolveIf(requirements.allSatisfied)
        || import(
            /*webpackChunkName:"polyfill-esFeatures"*/
            '@babel/polyfill/dist/polyfill.min.js'),

        // window.Intl: we only load locale.en for old browsers, we could do more but whatev.
        resolveIf('Intl' in window)
        || promiseScript('https://cdn.polyfill.io/v2/polyfill.min.js?features=Intl.~locale.en', true),

        // Adapter for modern browsers to deal with transpiled ES5 components.
        // If we haven't transpiled to ES5 then don't need to bother since we're using native ES6 custom elements,
        // or if the browser is old and doesn't use native customElements then no need for the adapter either.
        // References:
        // https://github.com/webcomponents/webcomponentsjs
        // https://github.com/Polymer/tools/blob/master/packages/build/src/custom-elements-es5-adapter.ts
        resolveIf(!options.es5 || !('customElements' in window))
        || import(
            /*webpackChunkName:"polyfill-customElementsES5Adapter"*/
            '@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js'),

        // Import the webcomponents polyfill-loader, which in-turn may load the necessary polyfill modules.
        // References:
        // https://github.com/webcomponents/webcomponentsjs
        // https://webpack.js.org/api/module-methods/ (eager: include in the bundle rather than as a separate file, synchronous)
        import(
            /*webpackMode:"eager"*/
            /*webpackChunkName:"polyfill-webcomponentsLoader"*/
            '@webcomponents/webcomponentsjs/webcomponents-loader.js')
            .then(_ => new Promise(res => { WebComponents.waitFor(res); })),

        // Web-Animations polyfills.
        import(
            /*webpackMode:"eager"*/
            /*webpackChunkName:"polyfill-webAnimations"*/
            'web-animations-js/web-animations-next-lite.min.js')

    ]);
};